var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"f-1",attrs:{"id":"home"}},[_c('m-img',{staticClass:"kv_bg",attrs:{"src":require("@/v2/pad_auto/assets/images/kv_bg.jpg")}}),_c('kv_title',{staticClass:"kv_title"}),_c('VideoMask',{attrs:{"videoSrc":_vm.videoSrc}},[_c('div',{ref:"promotional",staticClass:"promotional_btn"},[_vm._v(" 观看宣传片 "),_c('VideoPlay')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }